// extracted by mini-css-extract-plugin
export default {"noise":"NoiseOverlay_noise__SRsIC"};